import { BiPrinter } from "react-icons/bi";
import { BiExitFullscreen } from "react-icons/bi";
import { BiFullscreen } from "react-icons/bi";
import { FaRegFileWord } from "react-icons/fa";
import { FaRegFileExcel } from "react-icons/fa";
import { FaRegFilePdf } from "react-icons/fa";
import { BiSend } from "react-icons/bi";
import React from 'react';
import { useTranslation } from '../hx/useTranslation';
import '../../styles/main.css';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../fx/FxLog';
import * as FxFetch from '../fx/FxFetch';
import CxSnackbar from '../cx/CxSnackbar';
import CxDlgAlert from '../cx/CxDlgAlert';
import CxToolbar from '../cx/CxToolbar';
import CxButton from '../cx/CxButton';
import CxIconButton from '../cx/CxIconButton';
import CxIconButtonNew from '../cx/CxIconButtonNew';
import CxDialog from '../cx/CxDialog';
import CxNumber from '../cx/CxNumber';
import CxImageSignatureEditor from '../cx/CxImageSignatureEditor';
import CxDlgPin from '../cx/CxDlgPin';
import { StoreFile, isApp } from "./GxStore";
import { useSessionStorage } from '../hx/useSessionStorage';
import * as FxFile from '../fx/FxFile';
import { Document, Page, pdfjs } from 'react-pdf';
import "../../styles/ReactPdf/ReactPdf.css";
import ScrollContainer from 'react-indiana-drag-scroll';
import { useNav } from '../hx/useNav';
import { BsHandThumbsUp } from "react-icons/bs";
import GxDlgSend from './GxDlgSend';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useOutletContext } from "react-router-dom"; // Añadido

const useStyles = makeStyles((theme) => ({
  parentDiv: (props) => ({
    overscrollBehaviorY: 'none', /* 17-09-2026 evita refresco en los tablets al deslizar el dedo en la pantalla */
    marginTop: props.isFullScreenMode ? '0px' : '-4px',
    position: props.isFullScreenMode ? 'fixed' : 'relative',
    top: props.isFullScreenMode ? 0 : 'auto',
    left: props.isFullScreenMode ? 0 : 'auto',
    height: props.isFullScreenMode ? '100vh' : 'auto',
    zIndex: props.isFullScreenMode ? 9999 : 1,
    backgroundColor: 'var(--ibs_color_white)',
    overflowY: props.isFullScreenMode ? 'scroll' : 'visible',
    overflowX: 'hidden',
  }),
  toolbar: (props) => ({
    background: 'var(--ibs_color_white)',
    position: 'fixed',
    zIndex: 1,
    padding: '5px 0 0 0',
    transition: 'width 0.3s ease', // Suavizado para el movimiento del sidebar
    width: props.isDrawerOpen
      ? (props.isFullScreenMode 
          ? '100%' 
          : (props.boSidebarCollapsed 
              ? 'calc(100% - var(--main-drawer-width-collapsed))' 
              : 'calc(100% - var(--main-drawer-width))'))
      : (props.isFullScreenMode ? '100%' : `calc(100% - 0px)`),
  }),
  container: (props) => ({
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'flex-start',
    gap: 'var(--ibs_container_gap)',
    padding: '55px 0 0 0',
    margin: '10px',
    width: props.isFullScreenMode ? '100vw' : '100%',
    height: props.isFullScreenMode ? 'calc(100vh - 55px)' : 'auto',
    overflowY: props.isFullScreenMode ? 'scroll' : 'visible',
    overflowX: 'hidden',
  }),
  pdfNoShadow: (props) => ({
    '& .react-pdf__Page__textContent': {
      boxShadow: props.isDrawerOpen ? 'initial' : 'none !important',
      border: props.isDrawerOpen ? 'initial' : 'none !important',
    },
    '& .react-pdf__Document, & .react-pdf__Page': {
      boxShadow: props.isDrawerOpen ? 'initial' : 'none !important',
      border: props.isDrawerOpen ? 'initial' : 'none !important',
    },
    '& .react-pdf__Page canvas': {
      boxShadow: props.isDrawerOpen ? 'initial' : 'none !important',
      border: props.isDrawerOpen ? 'initial' : 'none !important',
    },
  }),
}));

// ─── Helpers para leer/escribir _lastPage directamente en sessionStorage ───────
function _readLastPage() {
  try {
    const stored = JSON.parse(sessionStorage.getItem('StoreFile') || '{}');
    return stored._lastPage || 1;
  } catch {
    return 1;
  }
}

function _writeLastPage(page) {
  try {
    const stored = JSON.parse(sessionStorage.getItem('StoreFile') || '{}');
    stored._lastPage = page;
    sessionStorage.setItem('StoreFile', JSON.stringify(stored));
  } catch (e) {
    FxLog.errorx('GxViewer._writeLastPage', e);
  }
}
// ─────────────────────────────────────────────────────────────────────────────

const GxViewer = (props) => {
  const [{ trans }] = useTranslation();
  const theme = useTheme();
  const [{ navBack }] = useNav();
  
  // Recuperamos el contexto del sidebar desde el Outlet de MxMain
  const { boSidebarCollapsed } = useOutletContext() || {};

  const [isFullScreenMode, setIsFullScreenMode] = React.useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(window.innerWidth > theme.breakpoints.values.sm);

  // Pasamos boSidebarCollapsed al objeto de props de los estilos
  const classes = useStyles({ isFullScreenMode, theme, isDrawerOpen, boSidebarCollapsed });

  React.useEffect(() => {
    const handleResize = () => {
      setIsDrawerOpen(window.innerWidth > theme.breakpoints.values.sm);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [theme.breakpoints.values.sm]);

  React.useEffect(() => { // 17-09-2026. Quita F5 para que no refresque y salga de la pantalla maximizada bloqueada.
    const blockRefresh = (e) => {
      if (e.key === 'F5' || (e.ctrlKey && e.key === 'r')) {
        e.preventDefault();
      }
    };
    window.addEventListener('keydown', blockRefresh);
    return () => window.removeEventListener('keydown', blockRefresh);
  }, []);

  pdfjs.GlobalWorkerOptions.workerSrc = `/pdf.worker.min.js`;

  // eslint-disable-next-line no-unused-vars
  const [storeFile, setStoreFile] = useSessionStorage('StoreFile', StoreFile);

  const r_snack_prepare_signature_pad = React.useRef(null);
  const r_snack_required = React.useRef(null);
  const r_snack_op_successful = React.useRef(null);
  const r_snack_op_failed = React.useRef(null);

  const r_dlg_send = React.useRef(null);
  const r_dlg_signature = React.useRef(null);
  const r_dlg_alert_signed = React.useRef(null);
  const r_dlg_pin = React.useRef(null);

  const rf_goto_page = React.useRef(null);
  const rf_image_signature = React.useRef(null);

  const rf_toolbar = React.useRef(null);
  const rf_bn_sign = React.useRef(null);
  const rf_bn_export_pdf = React.useRef(null);
  const rf_bn_export_doc = React.useRef(null);
  const rf_bn_export_xls = React.useRef(null);
  const rf_bn_send = React.useRef(null);
  const rf_bn_print = React.useRef(null);
  const rf_bn_screenmode = React.useRef(null);

  const [numPages, setNumPages] = React.useState(null);

  const [pageNumber, setPageNumber] = React.useState(_readLastPage);

  const [dlgGotoPage, setDlgGotoPage] = React.useState(false);
  const [dlgSign, setDlgSign] = React.useState(false);

  const [zoom, setZoom] = React.useState(1.0);

  React.useEffect(() => {
    if (storeFile._scale) {
      setZoom(storeFile._scale);
    }
    return () => { /* cleanup */ }
    // eslint-disable-next-line
  }, []);

  function onDocumentLoadError(error) {
    FxLog.errorx('GxViewer.onDocumentLoadError', 'Error cargando documento PDF:', error);
    console.error('Detalles completos del error de carga de PDF:', error);
    if (error && typeof error === 'object') {
      console.error('Nombre del error (error.name):', error.name);
      console.error('Mensaje del error (error.message):', error.message);
      if (error.filename) console.error('Archivo del error (error.filename):', error.filename);
      if (error.lineno)   console.error('Línea del error (error.lineno):', error.lineno);
      if (error.colno)    console.error('Columna del error (error.colno):', error.colno);
      if (error.stack)    console.error('Stack trace del error (error.stack):', error.stack);
      if (error.originalError) console.error('Error original (error.originalError):', error.originalError);
      if (error.details)  console.error('Detalles adicionales del error (error.details):', error.details);
    }
    const pdfBase64 = storeFile.obPDF;
    console.log('Longitud total de obPDF:', pdfBase64.length);
    console.log('obPDF - Primeros 50 chars:', pdfBase64.substring(0, 50));
    console.log('obPDF - Últimos 50 chars:', pdfBase64.substring(pdfBase64.length - 50, pdfBase64.length));
  }

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    const saved = _readLastPage();
    if (!saved || saved > numPages) {
      gotoPage(1);
    }
  }

  function jump() {
    try {
      let thePage = rf_goto_page.current.getIntVal();
      if (thePage > numPages) thePage = numPages;
      if (thePage < 1) thePage = 1;
      gotoPage(thePage);
      setDlgGotoPage(false);
    } catch (error) {
      FxLog.errorx("GxViewer.jump", error);
    }
  }

  function gotoPage(thePageNumber) {
    _writeLastPage(thePageNumber);
    setPageNumber(thePageNumber);
  }

  function changePage(offset) {
    setPageNumber(prevPageNumber => {
      const newPage = prevPageNumber + offset;
      _writeLastPage(newPage);
      return newPage;
    });
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }

  const exportToPdf = () => {
    let byteArray = FxFile.base64ToArrayBuffer(storeFile.obPDF.replace('data:application/pdf;base64,', ''));
    FxFile.saveByteArray('PDF', storeFile.txFileNameInput, byteArray);
  }

  const exportToWord = () => {
    let byteArray = FxFile.base64ToArrayBuffer(storeFile.obDOC);
    FxFile.saveByteArray('DOC', storeFile.txFileNameInput, byteArray);
  }

  const exportToExcel = () => {
    let byteArray = FxFile.base64ToArrayBuffer(storeFile.obCSV);
    FxFile.saveByteArray('CSV', storeFile.txFileNameInput, byteArray);
  }

  const printPDF = () => {
    FxFile.printPDF(storeFile.obPDF);
  }

  const handleSign = () => {
    r_snack_prepare_signature_pad.current.setOpen(true);
    setDlgSign(true);
  }

  const doSignSave = () => {
    FxLog.infox('GxViewer.doSignSave', '...', storeFile._sign);
    try {
      let record = {};
      record['n_client_doc.inClientDoc'] = storeFile._sign.inClientDoc;
      record['n_client_doc.itDoc']       = storeFile._sign.itDoc;
      record['n_client_doc.inEmployee']  = storeFile._sign.inEmployee;
      record['n_client_doc.inClient']    = storeFile._sign.inClient;
      record['n_client_doc.dtSignature'] = storeFile._sign.dtSignature;
      if (isApp('vett') || isApp('spaw')) {
        record['n_client_doc.inAnimal'] = storeFile._sign.inAnimal;
      }

      Promise.all([FxFetch.doJsonX('clients/doc/cu', record)]).then((result) => {
        if (result[0]) {
          if (result[0].theValue === 'OK') {
            let inClientDoc = result[0].inClientDoc;
            FxLog.infox("GxViewer.doSignSave", "...inClientDoc:" + inClientDoc);
            rf_image_signature.current.save(inClientDoc);
            setDlgSign(false);
            r_dlg_alert_signed.current.setAutoClose(true);
            r_dlg_alert_signed.current.setOpen(true);
          }
        }
      });
    } catch (error) {
      FxLog.errorx("GxViewer.doSignSave", error);
    }
  }

  const doSignFinish = () => {
    Promise.all([setDlgSign(false)]).then((result) => {
      if (isFullScreenMode) {
        rf_bn_sign.current?.setVisible(false);
      } else {
        navBack();
      }
    });
  }

  const toggleFullScreenMode = () => {
    setIsFullScreenMode(prevMode => !prevMode);

    if (isFullScreenMode) {
      rf_bn_screenmode.current.setIcon(<BiFullscreen fontSize={25} />);
      rf_toolbar.current.setDisableBack(false);
      rf_bn_export_pdf.current?.setVisible(true);
      rf_bn_export_doc.current?.setVisible(true);
      rf_bn_export_xls.current?.setVisible(true);
      rf_bn_send.current?.setVisible(true);
      rf_bn_print.current?.setVisible(true);
    } else {
      rf_bn_screenmode.current.setIcon(<BiExitFullscreen fontSize={25} />);
      rf_toolbar.current.setDisableBack(true);
      rf_bn_export_pdf.current?.setVisible(false);
      rf_bn_export_doc.current?.setVisible(false);
      rf_bn_export_xls.current?.setVisible(false);
      rf_bn_send.current?.setVisible(false);
      rf_bn_print.current?.setVisible(false);
    }
  };

  return (
    <div>
      <div id='myGxViewer' className={classes.parentDiv}>
        <div id='myCxToolbar' className={classes.toolbar}>
          <CxToolbar xref={rf_toolbar} moduleName={trans('field.preview')} style={{ display: 'flex', gap: '15px' }}>
            {storeFile._sign && !storeFile._sign.isSigned && <CxButton xref={rf_bn_sign} label={trans('field.sign')}
              style={{ width: '80px', height: '23px', padding: '0px', borderRadius: '0px', backgroundColor: 'var(--ibs_color_red)', margin: '4px 10px 4px 4px' }}
              onClick={handleSign}
            />}
            <CxIconButton type="zoom_in" classType="ibs_iconbutton_toolbar" onClick={() => setZoom(zoom + 0.1)} />
            <CxIconButton type="zoom_out" classType="ibs_iconbutton_toolbar" onClick={() => setZoom(zoom - 0.1)} />
            <CxIconButtonNew xref={rf_bn_export_pdf} icon={<FaRegFilePdf fontSize={22} style={{ marginTop: '1px' }} />} classType="ibs_iconbutton_toolbar" onClick={exportToPdf} tooltip={trans('field.export_to_x', 'PDF')} />
            <CxIconButtonNew xref={rf_bn_export_doc} icon={<FaRegFileWord fontSize={22} style={{ marginTop: '1px' }} />} classType="ibs_iconbutton_toolbar" onClick={exportToWord} tooltip={trans('field.export_to_x', 'Word')} />
            <CxIconButtonNew xref={rf_bn_export_xls} icon={<FaRegFileExcel fontSize={22} style={{ marginTop: '1px' }} />} classType="ibs_iconbutton_toolbar" onClick={exportToExcel} tooltip={trans('field.export_to_x', 'Excel')} />
            <CxIconButtonNew xref={rf_bn_print} icon={<BiPrinter fontSize="24px" />} classType="ibs_iconbutton_toolbar" onClick={printPDF} tooltip={trans('field.print')} />
            {storeFile._send && <CxIconButtonNew xref={rf_bn_send} icon={<BiSend fontSize={25} />} classType="ibs_iconbutton_toolbar" onClick={() => r_dlg_send.current.setOpen(true)} tooltip={trans('field.send')} />}
            <CxIconButton type="move_first" classType="ibs_iconbutton_toolbar" onClick={() => gotoPage(1)} disabled={pageNumber <= 1} />
            <CxIconButton type="move_left" classType="ibs_iconbutton_toolbar" onClick={previousPage} disabled={pageNumber <= 1} />
            <div style={{ fontSize: '14px', marginTop: '4px', cursor: 'pointer' }} onClick={() => {
              Promise.all([setDlgGotoPage(true)]).then((result) => {
                rf_goto_page.current.setFocus();
              });
            }}>
              {pageNumber || (numPages ? 1 : '-')}/{numPages || '-'}
            </div>
            <CxIconButton type="move_right" classType="ibs_iconbutton_toolbar" onClick={nextPage} disabled={pageNumber >= numPages} />
            <CxIconButton type="move_last" classType="ibs_iconbutton_toolbar" onClick={() => gotoPage(numPages)} disabled={pageNumber >= numPages} />

            <CxIconButtonNew xref={rf_bn_screenmode}
              icon={<BiFullscreen fontSize={25} />}
              classType="ibs_iconbutton_toolbar"
              onClick={() => {
                if (isFullScreenMode) {
                  r_dlg_pin.current.setOpen(true);
                } else {
                  toggleFullScreenMode();
                }
              }}
              tooltip={trans('field.fullscreen_toggle')}
            />
          </CxToolbar>
        </div>

        <div className={classes.container}>
          <ScrollContainer
            style={{
              width: '100%',
              height: '100%',
              marginRight: '20px',
            }}>
            <Document
              file={storeFile.obPDF}
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadError={onDocumentLoadError}
              loading={`${trans('msg.loading')}...`}
              noData={trans('msg.report_too_much_data')}
              className={!isDrawerOpen ? classes.pdfNoShadow : ''}
            >
              <Page
                pageNumber={pageNumber}
                scale={zoom}
              />
            </Document>
          </ScrollContainer>
        </div>

        <CxDialog
          title={trans('msg.go_to_x').replaceAll('%s', trans('field.page') + '...')}
          open={dlgGotoPage}
          onOk={jump}
          onCancel={() => setDlgGotoPage(false)}
          height='200px'>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', width: 'var(--ibs_control_width_sm)' }}>
            <CxNumber xref={rf_goto_page} label={trans('field.page')} onEnter={jump} width="var(--ibs_control_width_sm)" decimals={0} />
          </div>
        </CxDialog>

        <CxDialog
          xref={r_dlg_signature}
          title={trans('field.sign')}
          open={dlgSign}
          onOk={() => doSignSave()}
          onCancel={() => setDlgSign(false)}
          height='330px'
          zIndex={10000}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', width: 'var(--ibs_control_width_lg)' }}>
            <CxImageSignatureEditor xref={rf_image_signature} url='clients/doc/signature' />
          </div>
        </CxDialog>

        <GxDlgSend xref={r_dlg_send} />

        <CxSnackbar xref={r_snack_prepare_signature_pad} severity="warning" value={trans('msg.prepare_signature_pad')} />
        <CxSnackbar xref={r_snack_required} severity="error" />
        <CxSnackbar xref={r_snack_op_successful} severity="success" value={trans('msg.operation_successful')} />
        <CxSnackbar xref={r_snack_op_failed} severity="error" value={trans('msg.operation_failed')} />

        <CxDlgAlert xref={r_dlg_alert_signed}
          text={trans('field.signed_in_accordance')}
          textColor={'var(--ibs_color_green)'}
          icon={<BsHandThumbsUp fontSize="30px" style={{ fill: 'var(--ibs_color_green)', paddingBottom: '10px' }} />}
          onAutoClose={doSignFinish}
        />

        <CxDlgPin xref={r_dlg_pin} onOk={() => toggleFullScreenMode()} />

      </div>
    </div>
  );
}

export default GxViewer;